import PlotView from "./MainTask/PlotView.js";
import React, { useState } from "react";
import "@firebase/firestore";

import Navbar from "./Navbar.js";
import Examination from "./MainTask/ExaminationForm.js";
import ResultForm from "./MainTask/ResultForm";

function MainTask(props) {
  if (props.location.state == null) {
    window.location = "/";
  }
  const status = props.location.state.status;
  const id = props.location.state.id;
  const blob = props.location.state.blob;
  const sampling = props.location.state.sampling;
  const result = props.location.state.result;
  const resultId = props.location.state.resultId;

  const [isEditing, setEditing] = useState(false);

  if (status === "done") {
    return (
      <div>
        <Navbar></Navbar>
        <div className="flexbox_mainTask d-flex">
          <div className="flexbox_reportView col-9">
            <h2 className="text-center mt-3">Przebieg Badania</h2>

            <PlotView blob={blob} sampling={sampling}></PlotView>
          </div>
          {isEditing === true ? (
            <div className="flexbox_form col-3 ">
              <Examination
                id={id}
                result={result}
                resultId={resultId}
              ></Examination>
            </div>
          ) : (
            <div className="flexbox_form col-3 ">
              <ResultForm result={result}></ResultForm>

              <div className="form-stickyPlace">
                <button
                  type="button"
                  class="form-stickyButton  mt-2"
                  onClick={() => setEditing(true)}
                >
                  Edytuj
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  } else if (status === "submitted") {
    return (
      <div>
        <Navbar></Navbar>
        <div className="flexbox_mainTask d-flex">
          <div className="flexbox_reportView col-9">
            <h2 className="text-center m-3">Przebieg Badania</h2>

            <PlotView
              blob={blob}
              sampling={sampling}
              resultId={resultId}
            ></PlotView>
          </div>

          <div className="flexbox_form col-3 ">
            <Examination id={id} result={result}></Examination>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Navbar></Navbar>
      <div className="ekg_bad">
        <h2>
          Badanie posiada niewłasciwy status skontaktuj się z administratorem
        </h2>
      </div>
    </div>
  );
}

export default MainTask;
